import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { usePricingMarket } from '../../context/PricingMarketContext';
import type { PricingMarket } from '../../types';
import { cn } from '../../utils/cn';

interface PricingMarketSwitchProps {
  className?: string;
  /** Header density */
  compact?: boolean;
}

export const PricingMarketSwitch: React.FC<PricingMarketSwitchProps> = ({
  className,
  compact = false,
}) => {
  const { t } = useLanguage();
  const { market, setMarket } = usePricingMarket();

  const options: { id: PricingMarket; label: string }[] = [
    { id: 'iraq', label: t('commercial.market.iraqTab', 'Iraq') },
    { id: 'international', label: t('commercial.market.internationalTab', 'International') },
  ];

  return (
    <div
      className={cn('bc-market-switch', compact && 'bc-market-switch--compact', className)}
      role="radiogroup"
      aria-label={t('commercial.pricingMarket', 'Pricing market')}
    >
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          role="radio"
          aria-checked={market === option.id}
          className={cn('bc-market-switch__btn', market === option.id && 'is-active')}
          onClick={() => setMarket(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
